import { render } from "./MToast.vue?vue&type=template&id=508c2018&scoped=true"
import script from "./MToast.vue?vue&type=script&lang=js"
export * from "./MToast.vue?vue&type=script&lang=js"

import "./MToast.vue?vue&type=style&index=0&id=508c2018&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508c2018"]])

export default __exports__